import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router'
import { ApiService } from '../../../shared/services/api.service'
import { Collection } from '../../../shared/interfaces/collection.interface'

@Component({
  selector: 'app-embed-collection-component',
  templateUrl: './embed-collection.component.html',
  styleUrls: ['./embed-collection.component.scss']
})
export class EmbedCollectionComponentComponent implements OnInit {

  loading = true
  collection: Collection

  small = false

  constructor(
    private route: ActivatedRoute,
    private apiService: ApiService) {
  }

  ngOnInit() {
    this.route.params.subscribe(p => {
      this.apiService.getCollection(p.collectionId)
        .subscribe((c: Collection) => {
          this.collection = c
          this.loading = false
        })
    })

    this.route.queryParams.subscribe(p => {
      this.small = !!p.small
    })
  }

}



// WEBPACK FOOTER //
// C:/Users/Thomas/Projekte/palettes/src/app/collection/components/embed-collection/embed-collection.component.ts